<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
		</div>
		<Button class="submit-process" v-on:click='submit' v-bind:disabled="isDisabled" v-bind:loading="formLoading" size="large" type="primary"> 提交
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import wx from 'weixin-js-sdk'
	import stringUtils from "../assets/js/stringUtil.js";
	import {
		initWxConfig
	} from '../api/jssdk.js';
	import {
		getTemplateInfo,
		submitProcess
	} from '@/api/approval'
	import {
		getRelation
	} from '@/api/employee'
  import { getSelectorNames } from "../utils/firsthandearlywarning/index"

	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				formLoading: false,
				listLoading: false,
				isDisabled: false,
        yshowArr: ["赔付费用","后置保证金比例","赔付费用文档全文","后置保证金文档全文"]
			}
		},
		created() {
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.spNo = this.$route.query.spNo;
			this.getEmployeeRelation();
			stringUtils.setAddIsShow(true);
		},
		methods: { //方法
			getTemplate:async function() {
				this.listLoading = true;
				var title = this.logInfo.fullName;
				var departs=this.logInfo.fullName.split("/");
				var jobLevel = this.logInfo.JobLevel;
				if (departs.indexOf("房友圈") == -1 &&
					departs.indexOf("商业地产部") == -1 &&
					departs.indexOf("二级市场营运中心") == -1 &&
					departs.indexOf("代理") == -1&&
					departs.indexOf("藤云") == -1&&
					this.isDisabled == false
				) {
					this.Message({
						message: '没有申请权限',
						type: 'error',
						duration: 1000
					});
					this.isDisabled = true;
				}
				getTemplateInfo(this.templateId).then(async response => {
					var controls = response.Body;
					controls.TemplateContent.Controls.forEach(async (item) => {
					  if (this.yshowArr.includes(item.Property.Title[0].Text)){
					    item.IsShow = false
            }
						if (item.Property.Title[0].Text == "部门 ") {
							if (departs.indexOf("华西区") > -1) {
								item.Value = departs[departs.indexOf("华西区") + 1] + "/" + this.logInfo.DeptName;
							}
							 if (departs.indexOf("非营业部") > -1) {
								item.Value = departs[departs.indexOf("非营业部") + 1] + "/" + this.logInfo.DeptName;
							}
						 if (departs.indexOf("营业部") > -1) {
								item.Value = departs[departs.indexOf("营业部") + 1] + "/" + this.logInfo.DeptName;
							}
							 if (departs.indexOf("其他") > -1) {
								item.Value = departs[departs.indexOf("其他") + 1] + "/" + this.logInfo.DeptName;
							}
						}
						if (item.Property.Title[0].Text == "所在部门") {
							if (departs.indexOf("房友圈") > -1||departs.indexOf("藤云") > -1) {
								item.Value=item.Config.Selector.Options.filter(o=>{ return o.Value[0].Text == "房友圈"})[0].Key;
							}  
							else if (departs.indexOf("二级市场营运中心") > -1||departs.indexOf("代理")>-1) {
								item.Value=item.Config.Selector.Options.filter(o=>{ return o.Value[0].Text == "二级市场营运中心/代理"})[0].Key;
							}
							else if (departs.indexOf("商业地产部") > -1) {
								item.Value=item.Config.Selector.Options.filter(o=>{ return o.Value[0].Text == "工商铺商业运营中心"})[0].Key;
							}
							item.Disable=true;
							item.IsShow=false;
						}
						
						if (item.Property.Title[0].Text == "逐级审批使用") {
							item.IsShow=false;
							item.Values = [];
							if (departs.indexOf("二级市场营运中心") > -1 || departs.indexOf("代理") > -1) {
								item.Values=this.getRelationList(this.relationList,8);
							}
							else if (departs.indexOf("商业地产部") > -1) {
								item.Values=this.getRelationList(this.relationList,6);
							}
							else if (departs.indexOf("房友圈") > -1||departs.indexOf("藤云") > -1) {
								item.Values=this.getRelationList(this.relationList,7);
							}
							if (item.Values == null || item.Values.length <= 0) {
								//审批节点无人，跳过
								item.Values.push(this.$store.state.defaultMember);
							}
						}
					});
					this.templateData = this.assignControl(controls, this.logInfo);
					this.templateData = await this.assignControlBySpNo(controls, this.spNo);
					this.listLoading = false;
				});
			},
			getEmployeeRelation() {
				getRelation(this.logInfo.EmpNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			getTextVal() {},
			getSelectorVal(val, name) {
        const selectors = this.templateData.TemplateContent.Controls.filter(e => e.Property.Title[0].Text === name);
        if (selectors.length <= 0) return
        const selector = selectors[0]
        const selectorVals = getSelectorNames(selector);
        console.log(selectors);
        for (let item of this.templateData.TemplateContent.Controls.filter(e => this.yshowArr.includes(e.Property.Title[0].Text))) {
          console.log(item);
          if (selectorVals.length === 0){
            item.IsShow = false
            item.Property.Require = 0
            continue
          }
          if (selectorVals.length === 2){
            item.IsShow = true
            item.Property.Require = 1
            continue
          }
          if (selectorVals[0] === "风险预警"){
            if (item.Property.Title[0].Text === "赔付费用文档全文" || item.Property.Title[0].Text === "赔付费用"){
              item.IsShow = true
              item.Property.Require = 1
            }
            if (item.Property.Title[0].Text === "后置保证金比例" || item.Property.Title[0].Text === "后置保证金文档全文"){
              item.IsShow = false
              item.Property.Require = 0
            }
          }
          if (selectorVals[0] === "后置保证金"){
            if (item.Property.Title[0].Text === "后置保证金比例" || item.Property.Title[0].Text === "后置保证金文档全文"){
              item.IsShow = true
              item.Property.Require = 1
            }
            if (item.Property.Title[0].Text === "赔付费用文档全文" || item.Property.Title[0].Text === "赔付费用"){
              item.IsShow = false
              item.Property.Require = 0
            }
          }
        }
      },
			tableOperation(val, type, datas) {
				if(type=='compute'){
					return;
				}
				this.tableoperation(val, type, datas, this);
			},
			submit() {
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}
				
				var SummaryList = [];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				
				var control2=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "部门"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请部门："+control2.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control3=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请时间"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请时间："+control3.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				this.templateData.SummaryList=SummaryList;
				
				isSubmit = true;
				this.listLoading = true;
				//提交
				submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
					isSubmit = false;
					this.listLoading = false;
				});
			}
		},
		watch: {
			relationList(val, oldVal) {
				if (oldVal == null) {
					this.getTemplate();
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
